import produce from 'immer';
import { atom } from 'ximple';
import { OctoBooking, OctoOrder } from '@repo/types';

type State = {
    octoOrder?: OctoOrder;
    isLoading: boolean;
};

type SetOctoOrderAction = {
    type: 'setOctoOrder';
    value: State['octoOrder'];
};

type SetOctoOrderLoadingAction = {
    type: 'setIsLoading';
    value: State['isLoading'];
};

type Actions = SetOctoOrderAction | SetOctoOrderLoadingAction;

export const octoOrderAtom = atom<State, Actions>({
    initialValue: {
        octoOrder: undefined,
        isLoading: false,
    },
    update: produce((state: State, { type, value }: Actions): State => {
        switch (type) {
            case 'setOctoOrder':
                state.octoOrder = value;
                break;
            case 'setIsLoading':
                state.isLoading = value;
                break;
        }

        return state;
    }),
});

export function setOctoOrder(value: SetOctoOrderAction['value']): SetOctoOrderAction {
    return { type: 'setOctoOrder', value };
}

export function setIsLoading(value: SetOctoOrderLoadingAction['value']): SetOctoOrderLoadingAction {
    return { type: 'setIsLoading', value };
}

export const selectActiveBookings = (state: State): OctoBooking[] | undefined => {
    if (!state.octoOrder) return undefined;

    return state.octoOrder.bookings.filter(
        (booking) => booking.status !== 'CANCELLED' && booking.status !== 'EXPIRED',
    );
};

export const selectOctoOrder = (state: State): OctoOrder | undefined => {
    return state.octoOrder;
};

export const selectIsLoading = (state: State): boolean => {
    return state.isLoading;
};
